<template>
  <v-card class="text-xs-center">
    <h1 class="text-pagename">Customer management</h1>
    <customerManage/>
  </v-card>
</template>

<script>
import customerManage from "../../components/back-office/CustomerManagement/CustomerListTable";
export default {
  components: {
    customerManage
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/"
      },
      {
        text: "Customer Management",
        disabled: true
      }
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  }
};
</script>

<style>
</style>
